import { Component, OnInit } from '@angular/core';
import { MiscService } from '../services/misc.service';
import { GlobalCfgService } from '../services/globalcfg.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'RealMeds';

  constructor(
    private miscService: MiscService,
    private globalCfgService: GlobalCfgService
  ) { }

  ngOnInit() {
  }
}
